module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-wordpress-inline-images/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Біостудент","short_name":"Біостудент","start_url":"/","background_color":"#e7f3fe","theme_color":"#065197","display":"standalone","icon":"src/images/icon-base.png"},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-glamor/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography.js"},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://1d42063943fa4d8c995992d4c348ff16@sentry.io/1887292","environment":"production","enabled":true},
    },{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-149407425-1","head":false,"siteSpeedSampleRate":10},
    }]
